import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {
  HalfWrapper,
  Section,
  SectionDetails,
  SectionSeparator,
  SectionSummary,
  SectionSummaryDescription,
  SectionSummaryTitle,
} from './styles';
import JoinedCurrentRoleDate from './career-components/joined-current-role-date';
import JoinedIndustryDate from './career-components/joined-industry-date';
import CurrentLocation from './career-components/current-location';
import RecentCareer from './career-components/recent-career';
import Accred from './career-components/accred';

const DetailsTitle = styled.p`
  text-transform: uppercase;
  margin: 15px 0;
`;

const SubSection = styled.section`
  &:first-child {
    margin-top: -15px;
  }

  & > div, & > article {
    margin: 15px 0;
  }
`;

export default function Career({
  organisation, joinedCurrentRoleAt, joinedIndustryAt,
  city, country, recentCareer, accred, onUpdate,
}) {
  return (
    <>
      <SectionSeparator />
      <Section className="form-group">
        <SectionSummary>
          <SectionSummaryTitle>experience</SectionSummaryTitle>
          <SectionSummaryDescription>
            Showcase your experience, including your current and previous role
            along with any industry accreditations or awards you have received.
          </SectionSummaryDescription>
        </SectionSummary>
        <SectionDetails>
          <SubSection>
            <DetailsTitle>your current role</DetailsTitle>
            <HalfWrapper>
              <JoinedCurrentRoleDate {...{ organisation, joinedCurrentRoleAt, onUpdate }} />
              <CurrentLocation {...{ city, country, onUpdate }} />
            </HalfWrapper>
          </SubSection>
          <SubSection>
            <DetailsTitle>where did you work previously?</DetailsTitle>
            <RecentCareer {...{ recentCareer, onUpdate }} />
            <JoinedIndustryDate value={joinedIndustryAt} onUpdate={onUpdate} />
            <Accred value={accred} />
          </SubSection>
        </SectionDetails>
      </Section>
    </>
  );
}

Career.propTypes = {
  accred: PropTypes.string,
  city: PropTypes.string,
  country: PropTypes.string,
  joinedCurrentRoleAt: PropTypes.string,
  joinedIndustryAt: PropTypes.string,
  organisation: PropTypes.string.isRequired,
  recentCareer: PropTypes.shape({
    joinedAt: PropTypes.string.isRequired,
    leftAt: PropTypes.string,
    organisation: PropTypes.string.isRequired,
    position: PropTypes.string.isRequired,
  }),
  onUpdate: PropTypes.func,
};

Career.defaultProps = {
  accred: null,
  city: null,
  country: null,
  joinedCurrentRoleAt: null,
  joinedIndustryAt: null,
  recentCareer: null,
  onUpdate: () => null,
};
